import { AfterViewInit, Component, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';

import * as _ from 'lodash';

import { SubscriptionFacadeService } from '../../services/subscription-facade.service';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';
@Component({
    selector: 'investissement-progressif-table',
    templateUrl: './investissement-progressif-table.component.html',
    styleUrls: ['./investissement-progressif-table.component.scss'],
    standalone: false
})
export class InvestissementProgressifTableComponent
  extends EaSubscriptionBuilder
  implements OnInit, AfterViewInit
{
  hideAlert = false;
  _ = _;
  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }
  ngAfterViewInit(): void {}

  ngOnInit() {
    this.subscriptionFacade.initForm(this);
  }
  floored(value) {
    return Math.round(value * 100) / 100;
  }
  getTotalAv(data, total) {
    return (total * data?.repartition) / 100;
  }

  get totalAllocated() {
    return (
      this.floored(
        _(this.avOptionInvestissementProgressifRepartition.value)
          ?.map('repartition')
          .map(percent => +percent)
          .sum(),
      ) / 100
    );
  }
  get allocationPanel() {
    if (
      !this.avOptionInvestissementProgressifRepartition ||
      !this.avOptionInvestissementProgressifRepartition.value ||
      this.avOptionInvestissementProgressifRepartition.value.length == 0
    )
      return {
        display: 'info',
        icon: 'info',
        text: 'Renseignez vos investissements',
      };
    else if (this.totalAllocated > 1)
      return {
        display: 'danger',
        icon: 'error',
        text: `${Math.round(
          this.totalAllocated * 100,
        )}% au total - Vous ne pouvez pas repartir plus de 100% de l'investissement`,
      };
    else if (this.totalAllocated < 1)
      return {
        display: 'warning',
        icon: 'warning',
        text: `Il reste ${Math.round(
          this.options?.parameters
            ?.avOptionInvestissementProgressifMontantArbitrage *
            (1 - this.totalAllocated),
        )}€ de votre investissement à répartir, soit ${Math.round(
          (1 - this.totalAllocated) * 100,
        )}%`,
      };
    else if (
      _.filter(
        this.avOptionInvestissementProgressifRepartition.value,
        scpi => !scpi.repartition,
      ).length
    )
      return {
        display: 'danger',
        icon: 'error',
        text: 'Vous ne pouvez pas repartir 0% dans un support',
      };
    else if (this.totalAllocated == 1)
      return {
        display: 'success',
        icon: 'check',
        text: 'Félicitations, vos investissements sont répartis à 100%',
      };
  }

  getMessage(type: 'initial' | 'monthly') {
    return type === 'initial'
      ? {
          display: 'success',
          icon: 'check',
          text: this.totalAllocated * 100 + '%',
        }
      : {
          display: 'success',
          icon: 'check',
          text: '',
        };
  }
  deleteFields(index) {
    this.avOptionInvestissementProgressifRepartition.removeAt(index);

    this.avOptionInvestissementProgressifRepartition.markAsDirty();
  }

  onSubmit() {
    this.subscriptionFacade.selectErrorInputAndScroll(this);
    this.form.markAsDirty();

    if (this.form.valid) {
      this.subscriptionFacade.submitPledge(this);
    }
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
